import { useEffect, useRef } from "react";

import { $api, type components } from "@/shared/api";

import { forgetLanding, readLanding } from "../lib/landing";

type Me = components["schemas"]["MeOut"];

// Откуда пришёл новый игрок принимается только от аккаунта не старше суток
// (`dashboard.services.ATTRIBUTION_WINDOW`).
const NEW_ACCOUNT_MS = 24 * 60 * 60 * 1000;

// После входа: новый аккаунт — отправить запомненный первый заход (`POST /api/attribution`)
// один раз и забыть его; старый — просто забыть. Бэкенд пишет источник один раз на игрока,
// поэтому повтор безопасен и `Idempotency-Key` не нужен.
export const useRecordLanding = (user: Me | undefined) => {
  const { mutate } = $api.useMutation("post", "/api/attribution");
  const sentFor = useRef<number | null>(null);
  useEffect(() => {
    if (user === undefined || user.steam_id === null || sentFor.current === user.id) {
      return;
    }
    sentFor.current = user.id;
    const landing = readLanding();
    if (landing === null) {
      return;
    }
    if (Date.now() - Date.parse(user.joined_at) > NEW_ACCOUNT_MS) {
      forgetLanding();
      return;
    }
    mutate({ body: landing }, { onSuccess: forgetLanding });
  }, [user, mutate]);
};
